export enum PriorityLevel {
  INFORMATION = 'INFORMATION',
  WARNING = 'WARNING',
  ALARM = 'ALARM',
  CRITICAL = 'CRITICAL'
}
